<template>
  <div class="v-login-registerbox">
    <span class="register-back"
      v-if="step > 1"
      @click="toPrev"
    >
      <!-- eslint-disable -->
      <svg t="1579254629022" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2622" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18">
        <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8c-16.4 12.8-16.4 37.5 0 50.3l450.8 352.1c5.3 4.1 12.9 0.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" p-id="2623" fill="#b1b1b1"></path>
      </svg>
      <!-- eslint-disable -->
    </span>
    <div class="register-inner">
      <div class="v-login-registerbox__head">
        <login-head :isRegisterTab="true" v-on="$listeners" />
      </div>
      <div class="register-main" :class="{ 'error': errorTxt }" v-if="step === 1">
        <error-text v-if="errorTxt" :text="errorTxt"></error-text>
        <ul class="register-main__box">
          <li>
            <div class="label" :class="{ 'active': validMobile }">输入手机号</div>
            <input type="text" maxlength="11"
              v-model.trim="form.mobile"
              @focus.stop="focusHideError('mobile')"
              @blur="checkMobile(true)"
              @keyup.stop="dueMobile"
            />
          </li>
          <li class="captcha-li" v-if="isNeedImgCaptcha">
            <div class="captcha-ipt">
              <div class="label" :class="{ 'active': validImgCaptcha }">图形验证码</div>
              <input type="text" maxlength="5"
                v-model.trim="form.imgCaptcha"
                @focus.stop="focusHideError('captcha')"
                @blur="checkImgCaptcha(true)"
                @keyup.stop="dueImgCaptcha"
              />
            </div>
            <div class="captcha-img" @click="refreshImgCaptcha">
              <img :src="imgCaptchaUrl" alt="" />
            </div>
          </li>
          <li>
            <div class="label" :class="{ 'active': validCode }">验证码</div>
            <input type="text" maxlength="6"
              v-model.trim="form.code"
              @focus.stop="focus.code = true"
              @blur="checkCode(true)"
              @keyup.stop="dueCode"
            />
            <code-btn :mobile="form.mobile"
              @updateCaptcha="updateCaptcha"
              :imgCaptcha="form.imgCaptcha"
              :graph="graph"
              :type="useOptions.isRegisterAccount ? 'REG' : 'LOGIN'"
              @tipImgCaptcha="tipImgCaptcha"
            ></code-btn>
          </li>
          <li class="agreement-li">
            <agreement :graph="graph" @toggleAgreement="toggleAgreement" />
          </li>
          <li class="btn-li">
            <a class="btn" href="javascript:void(0)"
              v-if="useOptions.isRegisterAccount"
              :class="{ 'disable': isBtnMobileDisable }"
              @click="toVerifyMobile()">下一步</a>
            <a class="btn" href="javascript:void(0)"
              v-else-if="useOptions.isRegisterRole"
              :class="{ 'disable': isBtnMobileDisable }"
              @click="toSelectRole()">下一步</a>
            <a class="btn" href="javascript:void(0)"
              v-else
              :class="{ 'disable': isBtnMobileDisable }"
              @click="toRegister()">注册</a>
          </li>
        </ul>
      </div>
      <div class="register-main" :class="{ 'error': errorTxt }" v-if="useOptions.isRegisterAccount && step === 2">
        <error-text v-if="errorTxt" :text="errorTxt"></error-text>
        <ul class="register-main__box">
          <li>
            <div class="label" :class="{ 'active': validUsername }">注册账号</div>
            <input type="text" maxlength="20"
              v-model.trim="form.username"
              @focus.stop="focus.username = true"
              @blur="checkUsername(true)"
              @keyup.stop="dueUsername"
            />
          </li>
          <li>
            <div class="label" :class="{ 'active': validPassword }">密码</div>
            <input :type="showPwd ? 'text' : 'password'" maxlength="20"
              v-model.trim="form.password"
              @focus.stop="focus.password = true"
              @blur="checkPassword(true)"
              @keyup.stop="duePassword"
            />
            <div class="intensity-tips" v-if="intensityTips">{{intensityTips}}</div>
            <show-pwd @togglePwd="togglePwd"></show-pwd>
          </li>
          <!-- <li>
            <div class="label" :class="{ 'active': validConfirmPassword }">再次确认密码</div>
            <input :type="showConfirmPwd ? 'text' : 'password'" maxlength="20"
              v-model.trim="form.confirmPassword"
              @focus.stop="focus.confirmPassword = true"
              @blur="checkConfirmPassword(true)"
              @keyup.stop="dueConfirmPassword"
            />
            <show-pwd @togglePwd="toggleConfirmPwd"></show-pwd>
          </li> -->
          <li class="btn-li">
            <a class="btn" href="javascript:void(0)"
              :class="{ 'disable': isBtnAccountDisable }"
              v-if="!useOptions.isRegisterRole"
              @click="toRegisterWithAccount()">完成注册</a>
            <a class="btn" href="javascript:void(0)" 
              :class="{ 'disable': isBtnAccountDisable }"
              v-else @click="toSelectRole()">下一步</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import defaults from './libs/defaults';
import { ENV_API_HOST, PHONE_TYPE } from './libs/constants';
import LoginHead from './components/LoginHead.vue';
// import ErrorTips from './components/ErrorTips.vue';
import ErrorText from './components/ErrorText.vue';
import Agreement from './components/Agreement.vue';
import ShowPwd from './components/ShowPwd.vue';
import CodeBtn from './components/CodeBtn.vue';
import {
  unValidName,
  unValidPwd,
  unValidMoblie,
  unValidCode,
  unValidImgCaptcha,
  cmdRSAEncrypt,
  checkIntensity,
  unValidAgreement,
} from './libs/validate';
import {
  apiLogin,
  apiVerifyCode,
  apiRegUser,
} from './libs/service';

export default {
  name: 'v-login-registerbox',
  props: {
    options: { type: Object, default: () => ({}) },
  },
  components: {
    LoginHead,
    ErrorText,
    Agreement,
    // ErrorTips,
    ShowPwd,
    CodeBtn,
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        confirmPassword: '',
        mobile: '',
        code: '',
        imgCaptcha: '',
        isAgreement: 1,
        loginType: PHONE_TYPE,
      },
      focus: {
        username: false,
        password: false,
        confirmPassword: false,
        mobile: false,
        account: false,
        code: false,
        imgCaptcha: false,
      },
      tips: {
        username: '',
        password: '',
        confirmPassword: '',
        mobile: '',
        code: '',
        agreement: '',
        imgCaptcha: '',
      },
      imgCaptchaUrl: '',
      step: 1,
      errorTxt: '',
      intensityTips: '',
      showPwd: false,
      showConfirmPwd: false,
      isNeedImgCaptcha: false,
    };
  },
  computed: {
    useOptions() {
      return Object.assign({}, defaults, this.options);
    },
    graph() {
      this.refreshImgCaptcha();
      return ENV_API_HOST[this.useOptions.env].graph;
    },
    validMobile() {
      return this.focus.mobile || this.form.mobile;
    },
    validImgCaptcha() {
      return this.focus.imgCaptcha || this.form.imgCaptcha;
    },
    validCode() {
      return this.focus.code || this.form.code;
    },
    validUsername() {
      return this.focus.username || this.form.username;
    },
    validPassword() {
      return this.focus.password || this.form.password;
    },
    // validConfirmPassword() {
    //   return this.focus.confirmPassword || this.form.confirmPassword;
    // },
    isBtnMobileDisable() {
      if (!this.useOptions.isBtnStatus) {
        return false;
      }
      if (this.form.mobile
      && this.form.code
      && (!this.isNeedImgCaptcha || (this.isNeedImgCaptcha && this.form.imgCaptcha))
      && this.form.isAgreement) {
        return false;
      }
      return true;
    },
    isBtnAccountDisable() {
      if (!this.useOptions.isBtnStatus) {
        return false;
      }
      // if (this.form.username && this.form.password && this.form.confirmPassword) {
      if (this.form.username && this.form.password) {
        return false;
      }
      return true;
    },
  },
  created() {
    this.step = 1;
    this.refreshImgCaptcha();
  },
  methods: {
    // 一步注册
    toRegister(onSuccess) {
      if (this.isBtnMobileDisable) {
        return;
      }
      const errTxt = this.checkMobileForm();
      if (errTxt) {
        this.errorTxt = errTxt;
        return;
      }
      const data = {
        loginType: this.form.loginType,
        mobile: this.form.mobile,
        captcha: this.form.code,
        agreement: 'on',
        isAgreement: this.form.isAgreement,
        hasAgreement: this.form.isAgreement,
      };
      apiLogin(
        this.graph,
        data,
        (result) => {
          // 注册成功
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(result);
          } else if (this.useOptions.registerCallback && typeof this.useOptions.registerCallback === 'function') {
            this.useOptions.registerCallback(result);
          }
        },
        (result) => { // 注册失败
          this.errorTxt = result && result.errorMessage ? result.errorMessage : '网络异常，注册失败';
        },
      );
    },
    // 注册-校验手机信息
    toVerifyMobile() {
      if (this.isBtnMobileDisable) {
        return;
      }
      this.errorTxt = this.checkMobileForm();
      if (this.errorTxt) {
        return;
      }
      apiVerifyCode(this.graph, this.form.mobile, this.form.code, () => {
        this.step = 2;
      }, (msg) => {
        this.errorTxt = msg || '网络异常，注册失败';
      });
    },
    // 手机号输入处理逻辑
    dueMobile() {
      // 实时校验
      if (this.useOptions.isRealtimeCheck) {
        // this.checkMobile();
        if (!this.form.code) {
          this.tips.code = '';
        }
        if (!this.form.imgCaptcha) {
          this.tips.imgCaptcha = '';
        }
      }
    },
    // 手机验证码输入处理逻辑
    dueCode() {
      if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkCode();
      }
    },
    // 图片验证码输入处理逻辑
    dueImgCaptcha() {
      if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkImgCaptcha();
      }
    },
    // 用户名输入处理逻辑
    dueUsername() {
      if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkUsername();
      }
    },
    // 密码输入处理逻辑
    duePassword() {
      if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkPassword();
      }
      this.intensityTips = checkIntensity(this.form.password);
    },
    dueConfirmPassword(e) {
      if (e.keyCode === 13) {
        this.toLogin();
      } else if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkConfirmPassword();
      }
    },
    // 去选择用户角色
    toSelectRole() {
      const emitSetRoles = (result) => {
        this.$emit('registerCallback', result);
      };
      if (this.useOptions.isRegisterAccount) {
        this.toRegisterWithAccount(emitSetRoles);
      } else {
        this.toRegister(emitSetRoles);
      }
    },
    // 注册-填写用户信息完成
    toRegisterWithAccount(onSuccess) {
      if (this.isBtnAccountDisable) {
        return;
      }
      this.errorTxt = this.checkAccountForm();
      if (this.errorTxt) {
        return;
      }
      apiRegUser(this.graph, {
        mobile: this.form.mobile,
        username: this.form.username,
        password: cmdRSAEncrypt(this.form.password),
        // confirmPassword: cmdRSAEncrypt(this.form.confirmPassword),
        redirect_uri: '',
      },
      (result) => {
        // 注册成功
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(result);
        } else if (this.useOptions.registerCallback && typeof this.useOptions.registerCallback === 'function') {
          this.useOptions.registerCallback(result);
        }
      },
      (result) => { // 注册失败
        this.errorTxt = result && result.errorMessage ? result.errorMessage : '网络异常，注册失败';
        if (this.useOptions.registerCallback && typeof this.useOptions.registerCallback === 'function') {
          this.useOptions.registerCallback(result);
        }
      });
    },
    // 上一步
    toPrev() {
      this.errorTxt = '';
      this.step -= 1;
      if (this.step === 2 && !this.useOptions.isRegisterAccount) {
        this.step -= 1;
      }
    },
    // 刷新图片验证码
    refreshImgCaptcha() {
      this.imgCaptchaUrl = `${ENV_API_HOST[this.useOptions.env].graph}/captcha/getMoblieImgCaptcha?timestamp=${new Date().getTime()}`;
    },
    tipImgCaptcha(msg, isRefresh) {
      this.errorTxt = msg || '';
      if (isRefresh) {
        this.refreshImgCaptcha();
      }
    },
    // checkAgreement() {
    //   this.tips.agreement = this.form.isAgreement ? '' : '请阅读并勾选协议';
    // },
    toggleAgreement(isCheck) {
      this.form.isAgreement = isCheck ? 1 : 0;
      // this.checkAgreement();
    },
    // 检验数据
    checkMobileForm() {
      const errMobile = unValidMoblie(this.form.mobile);
      const errCode = unValidCode(this.form.code);
      let errCaptcha = '';
      if (this.isNeedImgCaptcha) {
        errCaptcha = unValidImgCaptcha(this.form.imgCaptcha);
      }
      const argErr = unValidAgreement(this.form.isAgreement);
      return errMobile || errCode || errCaptcha || argErr;
    },
    checkAccountForm() {
      const errUsername = unValidName(this.form.username);
      const errPassword = unValidPwd(this.form.password);
      // let errConfirmPassword = '';
      // if (this.form.password !== this.form.confirmPassword) {
      //   errConfirmPassword = '两次密码输入不一致';
      // }
      // return errUsername || errPassword || errConfirmPassword;
      return errUsername || errPassword;
    },
    checkUsername(isBlur) {
      // this.tips.username = unValidName(this.form.username);
      if (this.focus.username && isBlur === true) {
        setTimeout(() => {
          this.focus.username = false;
        }, 200);
      }
    },
    checkPassword(isBlur) {
      // this.tips.password = unValidPwd(this.form.password);
      if (this.focus.password && isBlur === true) {
        setTimeout(() => {
          this.focus.password = false;
        }, 200);
      }
    },
    checkConfirmPassword(isBlur) {
      // if (this.form.password !== this.form.confirmPassword) {
      //   this.tips.confirmPassword = '两次密码输入不一致';
      // } else {
      //   this.tips.confirmPassword = '';
      // }
      if (this.focus.confirmPassword && isBlur === true) {
        setTimeout(() => {
          this.focus.confirmPassword = false;
        }, 200);
      }
    },
    checkMobile(isBlur) {
      // this.tips.mobile = unValidMoblie(this.form.mobile);
      if (this.focus.mobile && isBlur === true) {
        setTimeout(() => {
          this.focus.mobile = false;
        }, 200);
      }
    },
    checkCode(isBlur) {
      // this.tips.code = unValidCode(this.form.code);
      if (this.focus.code && isBlur === true) {
        setTimeout(() => {
          this.focus.code = false;
        }, 200);
      }
    },
    checkImgCaptcha(isBlur) {
      // this.tips.imgCaptcha = unValidImgCaptcha(this.form.imgCaptcha);
      if (this.focus.imgCaptcha && isBlur === true) {
        setTimeout(() => {
          this.focus.imgCaptcha = false;
        }, 200);
      }
    },
    // 显隐密码
    togglePwd(isShow) {
      this.showPwd = isShow;
    },
    toggleConfirmPwd(isShow) {
      this.showConfirmPwd = isShow;
    },
    // 账号与图形验证码focus时隐藏错误提示
    focusHideError(type) {
      if (type === 'mobile') {
        this.focus.mobile = true;
      } else {
        this.focus.imgCaptcha = true;
      }
      this.errorTxt = '';
    },
    // 点击获取验证码超过3次时出现图形验证码
    updateCaptcha(res) {
      this.isNeedImgCaptcha = res;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './libs/mixin.scss';

.v-login-registerbox {
  position: relative;
  height: 100%;
  ul, li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  a {
    color: rgba(0,0,0,0.45);
    text-decoration: none;
    outline: none;
  }
  .btn {
    @include loginBtn;
    width: 180px;
    margin: 0 auto;
    padding: 0;
  }
  .register-back {
    position: absolute;
    left: 20px;
    top: 20px;
    height: 18px;
    width: 18px;
    cursor: pointer;
  }
  .register-inner {
    padding: 40px 70px 0;
  }
  .register-tit {
    font-size: 20px;
    color: rgba(0,0,0,.85);
    text-align: center;
    margin: 0;
  }
  .register-main {
    position: relative;
    margin-top: 10px;
    li {
      position: relative;
      margin-top: 34px;
      .label {
        @include loginLabel;
      }
      input {
        @include loginInput;
      }
      &.btn-li {
        margin-top: 30px;
      }
      &.captcha-li {
        @include captchaItem;
      }
      &.agreement-li {
        margin-top: 20px;
      }
    }
    .agreement-icon {
      position: absolute;
      left: 0;
      top: 2px;
      background: url('./imgs/checkbox.png') center no-repeat;
      background-size: 18px auto;
      display: inline-block;
      width: 18px;
      height: 18px;
      cursor: pointer;
      vertical-align: middle;
      &.checked {
        color: $mainColor;
        background-image: url('./imgs/checkbox-on.png');
      }
    }
  }
  .register-others {
    position: absolute;
    left: 50%;
    bottom: 24px;
    width: 240px;
    margin-left: -120px;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    text-align: center;
  }
  .intensity-tips {
    font-size:12px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:17px;
    margin-top: 4px;
  }
}
.v-login-registerbox__head {
  padding-bottom: 30px;
}
</style>
